var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-buttons"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,staticClass:"select-buttons__button",class:{ 'm-selected': option.value === _vm.innerValue },on:{"click":function($event){_vm.innerValue = option.value}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }